import { render, staticRenderFns } from "./xplogin.vue?vue&type=template&id=f8cf3940&scoped=true&"
import script from "./xplogin.vue?vue&type=script&lang=js&"
export * from "./xplogin.vue?vue&type=script&lang=js&"
import style0 from "./xplogin.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./xplogin.vue?vue&type=style&index=1&id=f8cf3940&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f8cf3940",
  null
  
)

export default component.exports